<table class="table">
  <thead>
    <tr>
      <th>{{ "common.productName" | translate }}</th>
      <th style="align-items: start; display: flex">
        {{ "catalog.variant-name" | translate }}
      </th>

      <th>
        {{ "freeGift.freeGifts" | translate }}
      </th>

      <th>{{ "common.total-quantity" | translate }}</th>
      <th>{{ "package.unit-weight" | translate }}</th>
      <th>{{ "requestPurchase.sku" | translate }}</th>
      <th *ngIf="!readonly">{{ "common.action" | translate }}</th>
    </tr>
  </thead>
  <tbody *ngIf="item">
    <tr *ngFor="let line of getLines()">
      <td>
        <a
          class="button-ghost"
          [routerLink]="['/catalog/products', line.productVariant.productId]"
        >
          <span class="limit-name">
            {{ line.productVariant.product.translations[0].name }}
          </span>
          <clr-icon shape="arrow right" />
        </a>
      </td>

      <td class="flex flex-row" style="justify-content: center">
        <div *ngIf="!line.productVariant.product.customFields.freeGifts">
          <a
            class="button-ghost"
            [routerLink]="[
              '/catalog/products',
              line.productVariant.productId,
              'variants',
              line.productVariant.id
            ]"
          >
            <span class="limit-name">
              {{ line.productVariant.translations[0].name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>

          <div
            *ngIf="line.productVariant.product.customFields.freeGifts"
            class="freegift-badge button-ghost"
          >
            Free gift <clr-icon shape="shopping-bag" />
          </div>
        </div>

        <div *ngIf="line.productVariant.product.customFields.freeGifts">-</div>
      </td>

      <td>
        <div
          *ngIf="line.productVariant.product.customFields.freeGifts"
          class="flex flex-row"
          style="justify-content: center"
        >
          <a
            class="button-ghost"
            [routerLink]="[
              '/catalog/products',
              line.productVariant.productId,
              'variants',
              line.productVariant.id
            ]"
          >
            <span class="limit-name">
              {{ line.productVariant.translations[0].name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>

          <div
            *ngIf="line.productVariant.product.customFields.freeGifts"
            class="freegift-badge button-ghost"
          >
            Free gift <clr-icon shape="shopping-bag" />
          </div>
        </div>

        <div *ngIf="!line.productVariant.product.customFields.freeGifts">-</div>
      </td>

      <td>{{ line.quantity }}</td>
      <td>{{ line.productVariant.customFields.weight }}</td>
      <td>
        <div>
          {{ line.productVariant.sku }}
        </div>
      </td>

      <td *ngIf="!readonly">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;
            margin-left: 1rem;
          "
        >
          <div
            style="margin-left: 6px; color: black; cursor: pointer"
            (click)="editSku(line)"
          >
            <clr-icon size="24" shape="pencil"></clr-icon>
          </div>

          <div
            style="margin-left: 12px; color: black; cursor: pointer"
            (click)="removeSku(line)"
          >
            <clr-icon size="24" shape="trash"></clr-icon>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
